import React from "react";
import PropTypes from "prop-types";
import { useMutation } from "@apollo/react-hooks";
import { Button, Card, CardBody, CardHeader } from "reactstrap";
import Toast from "shared/toast";
import { withRedirectOnUnauthorized, withErrorMessage } from "shared/utils/graphQLErrorHelpers";

import { SendResetPasswordNotification } from "./Members.graphql";

const SendPasswordNotification = ({ memberID }) => {
  const [sendPasswordNotification, { loading: notificationSending }] = useMutation(
    SendResetPasswordNotification
  );

  return (
    <Card>
      <CardHeader tag="h3">Security</CardHeader>
      <CardBody>
        <label>
          <strong>
            Send a forgot password email to this user so they can reset their password.
          </strong>
        </label>
        <div className="justify-content-between">
          <Button
            color="secondary"
            onClick={() => {
              sendPasswordNotification({
                variables: { id: memberID }
              })
                .then(({ data }) => {
                  const { sendPasswordNotification } = data;
                  const { username } = sendPasswordNotification;
                  Toast.success(`Password reset email sent to ${username}.`);
                })
                .catch(
                  withRedirectOnUnauthorized(
                    withErrorMessage(message => {
                      Toast.error(message);
                    })
                  )
                );
            }}
            disabled={notificationSending}
          >
            Send email to reset password
          </Button>
        </div>
      </CardBody>
    </Card>
  );
};

SendPasswordNotification.propTypes = {
  memberID: PropTypes.string
};

export default SendPasswordNotification;
